// extracted by mini-css-extract-plugin
export default {"wrapper":"styles---wrapper---I5z3Q","heading":"styles---heading---XjizW","actions":"styles---actions---fsrxZ"};